module.exports = new __parcel__URL__("apply_c_faq_expanded_ja.b22372f8.webp").toString();